module.exports = __webpack_public_path__ + "static/media/coffee_hero_twitter_card.d3ff75fe.jpg";